import { render, staticRenderFns } from "./SavedResumes.vue?vue&type=template&id=7ff3bcc2&scoped=true"
import script from "./SavedResumes.vue?vue&type=script&lang=js"
export * from "./SavedResumes.vue?vue&type=script&lang=js"
import style0 from "./SavedResumes.vue?vue&type=style&index=0&id=7ff3bcc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff3bcc2",
  null
  
)

export default component.exports